import { render, staticRenderFns } from "./EmptyContentAlternative.vue?vue&type=template&id=3d674547&"
import script from "./EmptyContentAlternative.vue?vue&type=script&lang=ts&"
export * from "./EmptyContentAlternative.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports